import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['row', 'select'];

  connect() {
    this.filter();
  }

  filter() {
    const standard = this.selectTarget.value;

    this.rowTargets.forEach((row) => {
      const visible = standard === 'all' || row.dataset[standard] === 'true';
      row.classList.toggle('hidden', !visible);
    });
  }
}
